import './public-path.js'

// promise polyfill needed for IE11 to load tablesorter
import 'es6-promise/auto'

import "../stylesheets/studip-jquery-ui.scss"
// Basic scss support
import "../stylesheets/studip.scss"

import lodash from "lodash"
window._ = lodash

import "./jquery-bundle.js"

import "./init.js"
import "./bootstrap/responsive.js"
import "./bootstrap/vue.js"

import "./studip-ui.js"
import "./bootstrap/fullscreen.js"
import "./bootstrap/tfa.js"
import "./bootstrap/tables.js"
import "./bootstrap/studip_helper_attributes.js"
import "./bootstrap/header_magic.js"
import "./bootstrap/header_navigation.js"
import "./bootstrap/personal_notifications.js"
import "./bootstrap/dialog.js"
import "./bootstrap/jsupdater.js"
import "./bootstrap/files.js"
import "./bootstrap/messages.js"
import "./bootstrap/quick_search.js"
import "./bootstrap/multi_select.js"
import "./bootstrap/multi_person_search.js"
import "./bootstrap/skip_links.js"
import "./bootstrap/i18n_input.js"
import "./bootstrap/forms.js"
import "./bootstrap/drag_and_drop_upload.js"
import "./bootstrap/admin_sem_classes.js"
import "./bootstrap/calendar.js"
import "./bootstrap/cronjobs.js"
import "./bootstrap/contentbox.js"
import "./bootstrap/dates.js"
import "./bootstrap/tour.js"
import "./bootstrap/questionnaire.js"
import "./bootstrap/qr_code.js"
import "./bootstrap/startpage.js"
import "./bootstrap/course_wizard.js"
import "./bootstrap/big_image_handler.js"
import "./bootstrap/opengraph.js"
import "./bootstrap/actionmenu.js"
import "./bootstrap/article.js"
import "./bootstrap/copyable_links.js"
import "./bootstrap/selection.js"
import "./bootstrap/data_secure.js"
import "./bootstrap/tooltip.js"
import "./bootstrap/lightbox.js"
import "./bootstrap/application.js"
import "./bootstrap/global_search.js"
import "./bootstrap/search.js"
import "./bootstrap/mvv_difflog.js"
import "./bootstrap/members.js"
import "./bootstrap/avatar.js"
import "./bootstrap/raumzeit.js"
import "./bootstrap/settings.js"
import "./bootstrap/subcourses.js"
import "./bootstrap/tabbable_widget.js"
import "./bootstrap/clipboard.js"
import "./bootstrap/resources.js"
import "./bootstrap/resource-tree-widget.js"
import "./bootstrap/fullcalendar.js"
import "./bootstrap/gradebook.js"
import "./bootstrap/blubber.js"
import "./bootstrap/consultations.js"
import "./bootstrap/scroll_to_top.js"
import "./bootstrap/admin-courses.js"
import "./bootstrap/oer.js"
import "./bootstrap/courseware.js"
import "./bootstrap/external_pages.js"
import "./bootstrap/vips.js"
import "./bootstrap/admission.js"
import "./bootstrap/use-vue-components.js"

import "./mvv_course_wizard.js"
import "./mvv.js"
import "./feedback.js"
